import config from './config';
import useTicketSearchContext, {
  TicketSearchContextAttributes,
  TicketSearchOrigin
} from './manual-entry/use-ticket-search-context';
import { useHistory } from 'react-router';
import { History } from 'history';
import useBetsContext from './bets/use-bets-context';
import { TicketView } from './services';
import { isTicketOpen } from './bets/use-bets';

export type Pages = 'Home' | 'Bets' | 'TicketEntry' | 'Scan';
export type Paths = '' | 'bets' | 'manual-entry' | 'scan-bet' | 'ticket';

export const PageToPaths: Record<Pages, Paths> = {
  Home: '',
  TicketEntry: 'manual-entry',
  Bets: 'bets',
  Scan: 'scan-bet'
};
export const PathToPages: Record<Paths, Pages> = {
  '': 'Home',
  ticket: 'Home',
  'manual-entry': 'TicketEntry',
  bets: 'Bets',
  'scan-bet': 'Scan'
};

export function useTicketSearchNavigation() {
  const history = useHistory();
  const { setContext, clearContext } = useTicketSearchContext();

  return {
    goToTicketSearch,
    goToTicketSearchOrigin,
    goToHome: () => goToHome(history)
  };

  function goToTicketSearchOrigin(ticketSearchOrigin: TicketSearchOrigin | undefined) {
    !ticketSearchOrigin || ticketSearchOrigin === 'manual-entry'
      ? goToHome(history)
      : history.push(`/${ticketSearchOrigin}`);
  }

  function goToTicketSearch(ticketSearchContext?: TicketSearchContextAttributes) {
    if (!ticketSearchContext) {
      clearContext();
    } else {
      setContext(ticketSearchContext);
    }
    history.push('/manual-entry');
  }
}

export type TabQueryParameters = 'open' | 'settled';
export const BETS_TAB_QUERY = 'tickets';

export function useBetsNavigation() {
  const history = useHistory();
  const { setContext } = useBetsContext();

  return {
    goToTicket: (ticket: TicketView) => {
      setContext({ selectedTicketId: ticket.retailTicketId });
      goToBets(history, isTicketOpen(ticket) ? 'open' : 'settled');
    },
    goToOpenBets: () => goToBets(history, 'open'),
    goToSettledBets: () => goToBets(history, 'settled'),
    goToBets: () => goToBets(history),
    goToHome: () => goToHome(history)
  };

  function goToBets(history: History, tab?: TabQueryParameters) {
    history.push(tab ? `/bets?${BETS_TAB_QUERY}=${tab}` : '/bets');
  }
}

export function useScanBetNavigation() {
  const history = useHistory();
  return {
    goToScanBet: () => {
      history.push('/scan-bet');
    }
  };
}

function goToHome(history: History) {
  history.push('/');
}

export function goTo(url: string) {
  window.location.href = url;
}

export function goToNewWindow(url: string) {
  window.open(url, '_blank');
}

export function tryParseTicketSearchUrl(url: string) {
  const path = getHomePath() + 'ticket/';
  if (!url.startsWith(path)) {
    return undefined;
  }

  const subpath = url.substring(path.length);
  const index = subpath.indexOf('/');
  if (index > 0) {
    return undefined;
  }

  return subpath;
}

export function getPage(path: string): Pages {
  if (!path) {
    return 'Home';
  }

  const parsedMatch = path.match(/^\/[a-zA-Z-]*/)?.[0].substring(1);
  if (parsedMatch && Object.keys(PathToPages).includes(parsedMatch)) {
    return PathToPages[parsedMatch as Paths];
  }
  return 'Home';
}

function getHomePath() {
  return `${window.location.origin}${config.basePath}`;
}
